<template>
  <span class="receiving-product-detail-dialog">
    <i class="el-icon-search header-info-dialog-value icon-action" id="btn-receiving-product-detail" @click="handleOpenDialog" size="mini" icon="el-icon-plus"></i>
    <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="50%"
    append-to-body>
      <span slot="title">
        <el-row :gutter="20">
          <el-col :span="24">
            <span class="el-dialog__title">
              {{ $t('outbound.loads.unitDetails') }}
            </span>
             <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
              <el-button @click="handleSearch" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
            </el-tooltip>
            <span class="units-count span-small-list">
              <span class="el-pagination__title">{{ $t('outbound.loads.totalUnits') }}</span>
              {{ totalUnits }}
            </span>
            <span class="units-count span-small-list">
              <span class="el-pagination__title">{{ $t('outbound.loads.received') }}</span>
              {{ totalReceivedUnits }}
            </span>
          </el-col>
        </el-row>
      </span>
      <el-table
          :data="productList"
          v-loading="loading"
          id="receiving-unit-detail-data-list"
          size="mini"
          tooltip-effect="dark"
          width="80%"
          class="dark-blue-table"
          :empty-text="$t('common.noRecords')"
          @sort-change="handleSortChange"
          :default-sort="{prop: 'product', order: 'ascending'}"
          sortable
          stripe>
          <el-table-column
             prop="product"
            :label="$t('outbound.loads.product')"
            align="center"
            :min-width="30"
            sortable="custom"/>
          <el-table-column
             prop="dimensions"
            :label="$t('outbound.loads.dimensions')"
            align="center"
            :min-width="30"
            sortable="custom">
          </el-table-column>
          <el-table-column
            prop="numberOfUnits"
            :label="$t('outbound.loads.numberUnits')"
            align="center"
            :min-width="30"
            sortable="custom">
          </el-table-column>
        </el-table>
      <div id="receiving-product-detail-dialog-footer" slot="footer" class="pagination-footer" v-show="totalProducts > 0">
        <span class="el-pagination__total" slot>
          <span class="el-pagination__title" slot>{{ $t('outbound.loads.totalProducts') }}</span>
          {{ totalProducts }}
        </span>
        <el-pagination
            :page-sizes="sizes"
            :page-size="searchParams.rows"
            :current-page.sync="searchParams.page"
            @size-change="handleSearchChangeLimit"
            @current-change="handleSearchChangePage"
            :total="totalProducts"
            layout="sizes, prev, pager, next, jumper"
          >
      </el-pagination>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import constants from '@/utils/constants';

export default {
  name: 'ReceivingProductDetailDialog',
  props: {
    shipDate: {
      type: String,
      default: null
    },
    shipperAccountId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,
      productList: [],
      totalProducts: 0,
      totalUnits: 0,
      totalReceivedUnits: 0,
      loading: false,
      searchParams: {
        shipperAccountId: null,
        shipDate: null,
        rows: constants.TABLES.DEFAULT_LIMIT,
        page: constants.TABLES.DEFAULT_PAGE,
        pageResults: true,
        orderField: 'product',
        orderDirection: constants.TABLES.ORDER_DIRECTION.ascending
      }
    };
  },
  methods: {
    handleOpenDialog() {
      this.dialogVisible = true;
      this.searchParams.shipperAccountId = this.shipperAccountId;
      this.searchParams.shipDate = this.shipDate;
      this.handleSearch();
    },
    handleSearchChangeLimit(val) {
      this.searchParams.rows = val;
      this.searchParams.page = constants.TABLES.DEFAULT_PAGE;
      this.handleSearch();
    },
    handleSearchChangePage(val) {
      this.searchParams.page = val;
      this.handleSearch();
    },
    handleSortChange({ prop, order }) {
      this.searchParams.orderField = prop;
      this.searchParams.orderDirection = constants.TABLES.ORDER_DIRECTION[order];
      this.handleSearch();
    },
    handleSearch() {
      this.loading = true;
      this.$store.dispatch('loads/getShipperBreakdownProductDetails', this.searchParams).then(
        (response) => {
          this.productList = response.data;
          this.totalProducts = response.totalRows;
          this.totalUnits = response.totalUnits;
          this.totalReceivedUnits = response.totalReceivedUnits;
        }
      ).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
  .units-count.span-small-list {
    display: inline;
    margin-left: 1rem;
  }
</style>
